"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MigrationResponseDto = void 0;
class MigrationResponseDto {
}
exports.MigrationResponseDto = MigrationResponseDto;
//# sourceMappingURL=migration-response-dto.js.map